import { LucideIcon } from "lucide-react";
import React from "react";

interface ErrorStateCardProps {
    icon: LucideIcon;
    title: string;
    description: string | React.ReactNode;
    iconBgColor?: string;
    iconTextColor?: string;
}

export default function ErrorStateCard({
    icon: Icon,
    title,
    description,
    iconBgColor = "bg-red-100",
    iconTextColor = "text-red-700",
}: ErrorStateCardProps) {
    return (
        <div
            className="bg-white dark:bg-gray-900 rounded-3xl p-8 shadow-2xl text-center w-full mx-auto"
            style={{
                boxShadow: '0px 0px 0px #000000, 0px 4px 30px -4px rgba(0, 0, 0, 0.3)'
            }}
        >
            <div className={`w-16 sm:w-20 h-16 sm:h-20 rounded-full flex items-center justify-center ${iconBgColor} ${iconTextColor} mx-auto mb-6`}>
                <Icon className="h-6 sm:h-10 w-6 sm:w-10" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold mb-1 sm:mb-2">
                {title}
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mb-8 mx-auto whitespace-pre-line">
                {description}
            </p>
        </div>
    );
}
